import { render } from "./Bac.vue?vue&type=template&id=f49668a2&scoped=true"
import script from "./Bac.vue?vue&type=script&lang=js"
export * from "./Bac.vue?vue&type=script&lang=js"

import "./Bac.vue?vue&type=style&index=0&id=f49668a2&scoped=true&lang=css"
import "./Bac.vue?vue&type=style&index=1&id=f49668a2&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49668a2"]])

export default __exports__